var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20,
    viewBox: "0 0 20.001 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.854 10.146l-2-2-7.5-7.5a.5.5 0 00-.708 0l-7.5 7.5-2 2a.5.5 0 00.708.708L2 9.707V19.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V14h4v5.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V9.707l1.146 1.147a.5.5 0 00.708-.708zM17 19h-4v-5.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V19H3V8.707l7-7 7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.ada943db9f81260f1a1e23a4793bdf44.svg";
export { ForwardRef as ReactComponent };